import { ResponsiveBar } from "@nivo/bar";

import { InvestmentGraphic } from "components/InvestmentGraphicNew";

import { Typography } from "shared/ui/components/Typography";

import styles from "./InvestmentAnalysisChart.module.scss";

const _renderInfoPopover = ({ info }: { info: any }) => {
  return (
    <div className={styles.popover}>
      <Typography variant="bodyS" weight="light">
        {info.section1}
      </Typography>
      {info.section2 && (
        <Typography
          variant="bodyS"
          weight="light"
          className={styles.popoverSection}
        >
          {info.section2}
        </Typography>
      )}
    </div>
  );
};


const InvestmentAnalysisChart = ({
  variant,
  title,
  price,
  description,
  caption,
  details,
  data,
  info,
}: {
  variant: string;
  title: string;
  price: string;
  description: React.ReactNode;
  caption: string;
  details: string;
  data: any;
  info: any;
}) => {
  return (
    <InvestmentGraphic
      variant={variant}
      descriptionVariant={variant}
      title={title}
      price={price}
      description={description}
      caption={caption}
      details={details}
      infoPopover={_renderInfoPopover({ info: info })}
    >
      <div className={styles.chart}>
        <ResponsiveBar
          data={data}
          indexBy="chartItem"
          enableLabel
          enableGridY={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          axisBottom={null}
          axisLeft={null}
          colors={({ id, data }) => {
            return String(data[`${id}Color`]);
          }}
          labelPosition="end"
          labelOffset={10}
          labelTextColor="#131618"
          label={(labelItem: any) => {
            return labelItem.data.chartItem;
          }}
          tooltip={() => <></>}
          margin={{ top: 15, right: 0, bottom: 0, left: 0 }}
          theme={{
            labels: {
              text: {
                fontSize: 8,
              },
            },
          }}
        />
      </div>
    </InvestmentGraphic>
  );
};

export default InvestmentAnalysisChart;
